<template>
  <div class="h-screen flex items-center">
    <section class="relative mx-auto">
      <div class="max-w-6xl mx-auto px-4 sm:px-6">
        <div class="relative px-8 py-12 md:py-20 [border-image:linear-gradient(to_right,transparent,var(--color-slate-800),transparent)1]">
          <x-glow :type="2" />
          <div class="max-w-3xl mx-auto text-center">
            <div>
              <div class="inline-flex font-medium bg-clip-text text-transparent bg-linear-to-r from-purple-500 to-purple-200 pb-3">Error</div>
            </div>
            <h2 class="h2 bg-clip-text text-transparent bg-linear-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-4">{{ error.statusCode }}</h2>
            <p class="text-lg text-slate-400 mb-8">
              <span v-if="error.statusMessage">{{ error.statusMessage }}</span>
              <span v-else>Unknown error</span>
            </p>
            <div>
              <nuxt-link to="/"> Go Home </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script lang="ts">
import type { NuxtError } from "#app";

export default {
  props: {
    error: {
      type: Object as PropType<NuxtError>,
      required: true
    }
  },
  mounted() {
    console.log(this.error);
  }
};
</script>
